import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { APIHelperService } from './apiHelper.service';
import { of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PartnerDetailsService {

  constructor(
    private http: HttpClient,
    private apiHelper: APIHelperService
  ) {
    // no-op
  }

  getPartnerDetails(partnerId) {
    return this.http.get<any>(this.apiHelper.fillUrl('partnerDetail', {partnerId}, {}))
      .pipe(map(data => {
        return data;
      }), catchError(e => {
        return of({error: e});
      })
    );
  }
}
